module.exports = "/_next/static/images/ee1b86be50891d5888784f66b8de32e9-fogafin.png.webp";